import { ReactNode } from 'react';
import { ErrorReference, referenceLabel } from '../../utils/error-reference';

// The one user-facing message for an uncaught client-side crash. Shared by the ErrorBoundary
// default fallback, the router-root RouteErrorFallback and the global error modal in main.tsx so
// the wording can't drift between them.
export const UNKNOWN_ERROR_MESSAGE =
  'An unknown error has occurred. Details have been sent to the engineering team. Please reload the page or try again later.';

interface ErrorFallbackMessageProps {
  className: string;
  reference?: ErrorReference;
}

export const ErrorFallbackMessage = ({
  className,
  reference
}: ErrorFallbackMessageProps): ReactNode => (
  <div className={className}>
    {UNKNOWN_ERROR_MESSAGE}
    {reference?.id && (
      <>
        {' '}
        {referenceLabel(reference.source)}: <code>{reference.id}</code>
      </>
    )}
  </div>
);
